import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ClockIcon from '@/lib/assets/clock.svg';

import styles from './../PaymentPage.module.scss';

const calculateTimeLeft = (timestamp) => {
    const now = Math.floor(Date.now() / 1000);
    const difference = timestamp - now;

    if (difference <= 0) {
        return { minutes: 0, seconds: 0 };
    }

    const minutes = Math.floor(difference / 60);
    const seconds = difference % 60;

    return { minutes, seconds };
};

const CountDown = ({ timeRemaining, onPaymentResult, redirectURL }) => {
    const { t } = useTranslation();
    const [expiryTime] = React.useState(Math.floor(Date.now() / 1000) + timeRemaining);
    const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft(expiryTime));
    const [expiredNotified, setExpiredNotified] = React.useState(false);

    React.useEffect(() => {
        if (!timeRemaining) {
            return;
        }
        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft(expiryTime));
            if ((Date.now() / 1000) > expiryTime && !expiredNotified) {
                setExpiredNotified(true);
                onPaymentResult({ success: false, isTimeUp: true, data: { callback_url: redirectURL } });
            }
        }, 100);

        return () => clearInterval(interval);
    }, [expiryTime, redirectURL, onPaymentResult, expiredNotified, timeRemaining]);

    return (
        <div className={styles.remaining_time}>
            <ClockIcon alt="clock" />
            {timeRemaining === 0 ?
                <p>{t('order_expired')}</p>
                :
                <p>{t('timeLeft')}: {t('minuteWithCount', { count: timeLeft.minutes })} {t('secondWithCount', { count: timeLeft.seconds })}</p>
            }
        </div>
    );
};

CountDown.propTypes = {
    timeRemaining: PropTypes.number.isRequired,
    onPaymentResult: PropTypes.func,
    redirectURL: PropTypes.string,
};

export default CountDown;
